<template>
    <form class="sp-card sp-form" novalidate @submit.prevent="enviar">
        <div v-if="titulo" class="sp-form__header">
            <h3 class="sp-h3">{{ titulo }}</h3>
            <p class="sp-form__sub">Completa los datos y te responderemos en menos de 24 horas.</p>
        </div>

        <div class="sp-campo">
            <label :for="id('nombre')">
                <span>Nombre y negocio</span>
                <span class="sp-campo__req" aria-hidden="true">*</span>
            </label>
            <InputText
                :id="id('nombre')"
                v-model="form.nombre"
                :class="{ 'p-invalid': enviado && !form.nombre }"
                placeholder="Ej. Ana Gómez - Restaurante Doña María"
                autocomplete="name"
            />
        </div>

        <div class="sp-form__row">
            <div class="sp-campo">
                <label :for="id('email')">
                    <span>Correo electrónico</span>
                    <span class="sp-campo__req" aria-hidden="true">*</span>
                </label>
                <InputText
                    :id="id('email')"
                    v-model="form.email"
                    type="email"
                    :class="{ 'p-invalid': enviado && !emailValido }"
                    placeholder="tucorreo@dominio.com"
                    autocomplete="email"
                />
            </div>

            <div class="sp-campo">
                <label :for="id('celular')">
                    <span>Celular</span>
                    <span class="sp-campo__req" aria-hidden="true">*</span>
                </label>
                <InputMask
                    :id="id('celular')"
                    v-model="form.celular"
                    mask="999-999-9999"
                    :class="{ 'p-invalid': enviado && !form.celular }"
                    placeholder="300-000-0000"
                />
            </div>
        </div>

        <div class="sp-campo">
            <label :for="id('mensaje')">
                <span>Cuéntanos sobre tu establecimiento</span>
                <span class="sp-campo__req" aria-hidden="true">*</span>
            </label>
            <Textarea
                :id="id('mensaje')"
                v-model="form.descripcion"
                rows="4"
                :class="{ 'p-invalid': enviado && !form.descripcion }"
                placeholder="Tipo de negocio, municipio o vía nacional, y qué te gustaría promocionar en ruta."
            />
        </div>

        <!-- Consentimiento de Habeas Data -->
        <div class="sp-campo sp-campo--check" :class="{ 'sp-campo--error': enviado && !acepta }">
            <Checkbox v-model="acepta" :binary="true" :inputId="id('habeas')" />
            <label :for="id('habeas')">
                Autorizo el tratamiento de mis datos personales conforme a la
                <router-link to="/politica-privacidad">política de privacidad</router-link>
                para ser contactado por un asesor de Seway Plus.
            </label>
        </div>

        <button type="submit" class="sp-btn sp-btn--primary sp-btn--block sp-form__submit" :disabled="cargando">
            <i v-if="cargando" class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            <span v-else>{{ textoBoton }}</span>
            <i v-if="!cargando" class="pi pi-send" aria-hidden="true"></i>
        </button>
    </form>
</template>

<script>
import axios from 'axios';

let contador = 0;

export default {
    name: 'FormularioContacto',
    emits: ['enviado'],
    props: {
        titulo: { type: String, default: '' },
        textoBoton: { type: String, default: 'Enviar solicitud' },
        mensajeInicial: { type: String, default: '' }
    },
    data() {
        contador += 1;
        return {
            uid: 'sp-f' + contador,
            cargando: false,
            enviado: false,
            acepta: false,
            form: { nombre: '', email: '', celular: '', descripcion: this.mensajeInicial }
        };
    },
    watch: {
        mensajeInicial(valor) {
            if (!this.form.descripcion) this.form.descripcion = valor;
        }
    },
    computed: {
        emailValido() {
            return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((this.form.email || '').trim());
        },
        formCompleto() {
            return (
                !!this.form.nombre &&
                this.emailValido &&
                !!this.form.celular &&
                !!this.form.descripcion
            );
        }
    },
    methods: {
        id(campo) {
            return this.uid + '-' + campo;
        },
        enviar() {
            this.enviado = true;

            if (!this.formCompleto) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Información incompleta',
                    detail: 'Por favor completa todos los campos requeridos.',
                    life: 4000
                });
                return;
            }

            if (!this.acepta) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Falta tu autorización',
                    detail: 'Debes autorizar el tratamiento de datos para continuar.',
                    life: 4000
                });
                return;
            }

            this.cargando = true;
            axios
                .post('enviarcorreosolicitud', {
                    nombre: this.form.nombre,
                    email: this.form.email,
                    celular: this.form.celular,
                    descripcion: this.form.descripcion
                })
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: '¡Mensaje recibido con éxito!',
                        detail: 'Un asesor comercial se comunicará contigo prontamente.',
                        life: 5000
                    });
                    this.form = { nombre: '', email: '', celular: '', descripcion: '' };
                    this.acepta = false;
                    this.enviado = false;
                    this.$emit('enviado');
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'No pudimos enviar tu mensaje',
                        detail: 'Inténtalo de nuevo o escríbenos directamente por WhatsApp.',
                        life: 5000
                    });
                })
                .finally(() => {
                    this.cargando = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.sp-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: clamp(1.75rem, 3.5vw, 2.5rem);
    background: #ffffff;
    border-radius: var(--sp-radius-lg);
    border: 1px solid var(--sp-border);
    box-shadow: 0 14px 40px rgba(13, 48, 68, 0.08);
}

.sp-form__header {
    margin-bottom: 0.5rem;

    .sp-form__sub {
        color: var(--sp-text-soft);
        font-size: 0.92rem;
        margin-top: 0.35rem;
    }
}

.sp-form__row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
}

.sp-campo {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;

    label {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        color: var(--sp-navy);
        font-size: 0.9rem;
        font-weight: 700;
    }

    .sp-campo__req {
        color: var(--sp-orange);
    }

    :deep(.p-inputtext),
    :deep(.p-inputtextarea) {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1.5px solid var(--sp-border);
        border-radius: 12px;
        font-family: inherit;
        font-size: 0.95rem;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &:focus {
            border-color: var(--sp-orange);
            box-shadow: 0 0 0 3px rgba(235, 93, 27, 0.22);
        }
    }
}

.sp-campo--check {
    flex-direction: row;
    align-items: flex-start;
    gap: 0.75rem;
    margin-top: 0.25rem;

    label {
        color: var(--sp-text-soft);
        font-size: 0.85rem;
        font-weight: 500;
        line-height: 1.5;
    }

    a {
        color: var(--sp-orange);
        font-weight: 700;
        text-decoration: underline;
    }
}

.sp-campo--error {
    :deep(.p-checkbox .p-checkbox-box) {
        border-color: #d9342b;
    }

    label {
        color: #b32a22;
    }
}

.sp-form__submit {
    margin-top: 0.5rem;
    min-height: 50px;
}

@media (min-width: 576px) {
    .sp-form__row {
        grid-template-columns: 1fr 1fr;
    }
}
</style>
